import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

interface StudentMetrics {
  total_alunos: number;
  alunos_ativos: number;
  alunos_fieis: number;
  novos_alunos: number;
}

export function useStudentMetrics() {
  const [metrics, setMetrics] = useState<StudentMetrics>({
    total_alunos: 0,
    alunos_ativos: 0,
    alunos_fieis: 0,
    novos_alunos: 0
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchMetrics() {
      try {
        setLoading(true);
        const { data, error } = await supabase.rpc('get_student_metrics');

        if (error) throw error;

        if (data?.[0]) {
          setMetrics(data[0]);
        }
      } catch (err) {
        console.error('Erro ao buscar métricas:', err);
        setError(err instanceof Error ? err.message : 'Erro ao carregar métricas');
      } finally {
        setLoading(false);
      }
    }

    fetchMetrics();

    // Inscreve para atualizações em tempo real
    const channel = supabase
      .channel('metrics_changes')
      .on('postgres_changes', {
        event: '*',
        schema: 'public',
        table: 'acm_base'
      }, () => {
        fetchMetrics();
      })
      .subscribe();

    return () => {
      channel.unsubscribe();
    };
  }, []);

  return { metrics, loading, error };
}